const errorSnackState = {
  mensaje: "",
  errorObject: null,
  open: false,
  autoHideDuration: 3000000,
};

export default errorSnackState;

